import { render, staticRenderFns } from "./sw-widget-header-settings.vue?vue&type=template&id=ffe1801a&"
import script from "./sw-widget-header-settings.vue?vue&type=script&lang=tsx&"
export * from "./sw-widget-header-settings.vue?vue&type=script&lang=tsx&"
import style0 from "./sw-widget-header-settings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports